module.exports = __webpack_public_path__ + "media/images/pages/atom_logo-ce84ce8d6d7987d1981701e6b6faff74.png";